import { FC } from 'react';
import { useReportKnowledgeSuggestions } from '../model';
import { KnowledgeNodeSuggestionsList } from './KnowledgeNodeSuggestionsList';

type Props = {
  /** Текст, набранный после знака `@`; сужает список знаний */
  query: string;
  onSelect: (nodeId: number) => void;
};

/** Знания, предлагаемые к подстановке в комментарий: из той модели, по которой посчитано заключение. */
export const KnowledgeNodeSuggestions: FC<Props> = ({ query, onSelect }) => {
  const nodes = useReportKnowledgeSuggestions(query);

  if (nodes.length === 0) return null;

  return <KnowledgeNodeSuggestionsList nodes={nodes} onSelect={onSelect} />;
};
